import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import LoadingBar from 'react-top-loading-bar';
import {
  ExportTableType,
  PaginationSettings,
  topLoaderProgress,
} from '../../configs';
import { CallLogTableDataWeb, CommonFilter, Searchbar } from '../../features';
import { VendorCallLogPagedResponseModel } from '../../models/api/Call';
import { ApiSchemaFilter } from '../../models/api/filter';
import { useFunctionalityVendorCallLog } from '../hooks';
import { useFunctionalityVendorCallLogColumns } from '../hooks/functionalityVendorCallLogColumns';

export function PageVendorCallLog(): JSX.Element {
  const [loaderProgress, setLoaderProgress] = React.useState(0);
  const [isShowCommonFilter, setIsShowCommonFilter] = useState<boolean>(false);
  const [pageIndex, setPageIndex] = useState(
    PaginationSettings.initialPageIndex
  );
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [searchText, setSearchText] = useState<string>('');
  const [vendorCallLogData, setVendorCallLogData] =
    useState<VendorCallLogPagedResponseModel>(Object);
  const [pagedCallListCount, setPagedCallListCount] = useState(0);

  let initialFilterData: ApiSchemaFilter = {
    filterQueries: [],
    sortQuery: {},
  };
  const [filterData, setFilterData] =
    useState<ApiSchemaFilter>(initialFilterData);
  const [filterDataChange, setFilterDataChange] = useState<number>(0);

  const { LoadVendorCallLog } = useFunctionalityVendorCallLog({
    pageSize: pageSize,
    pageNo: pageIndex,
    searchText: searchText?.trimStart(),
    setLoaderProgress,
    filterData,
  });

  useEffect(() => {
    setLoaderProgress(topLoaderProgress.start);
    LoadVendorCallLog().then((r) => {
      setLoaderProgress(topLoaderProgress.complete);

      if (r?.data) {
        setVendorCallLogData(r?.data);
        setPagedCallListCount(
          r?.data.totalCount ?? r?.data.calls?.length ?? 0
        );
      }
    });
  }, [pageSize, pageIndex, filterData, searchText]);

  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const { vendorCallLogColumns } = useFunctionalityVendorCallLogColumns();

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };

  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />
      <h4 className="my-3 font-weight-light">Vendors Logs</h4>
      <div className="call-log-page ">
        <div className="row">
          <div className="col-12 mb-3">
            <Searchbar
              showFilter={true}
              showExportOptions={true}
              showPdfOption={false}
              showColumnSelectionOption={false}
              filterPanel={'commonFilterPanel'}
              searchText={searchText}
              handleSearch={handleSearch}
              showAutoRefresh={true}
              tableType={ExportTableType.VendorCall}
              downloadedFileName={'VendorCallLog'}
              columnSelection={[]}
              setLoaderProgress={setLoaderProgress}
              filterData={filterData}
              setIsShowCommonFilter={setIsShowCommonFilter}
            />
          </div>
          {isShowCommonFilter ? (
            <div className="col-12 px-0 mb-3">
              <CommonFilter
                setFilterData={setFilterData}
                setLoaderProgress={setLoaderProgress}
                setFilterDataChange={setFilterDataChange}
                pageName="callLogPage"
                pageType="general"
                callLogVariant="vendor"
                setPageIndex={setPageIndex}
                disableTopMargin={true}
              />
            </div>
          ) : null}

          <CallLogTableDataWeb
            pagingKey="PageVendorCallLog"
            loaderProgress={loaderProgress}
            pageHeader="Vendors Logs"
            isPageEnabled={true}
            tableData={vendorCallLogData.calls ?? []}
            tableHeaders={vendorCallLogColumns}
            pageIndex={pageIndex}
            pageSize={pageSize}
            count={pagedCallListCount}
            searchText={searchText}
            filterDataChange={filterDataChange}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
            enableRowClick={false}
          />
        </div>
      </div>
    </>
  );
}
